import React, { PureComponent } from 'react';

import { copyToClipboard as copyFn } from '@Sage/ssm-utils';
import PropTypes from 'prop-types';

import CopyIcon from 'components/SvgIcons/Copy';

import './styles.scss';

class CopyLink extends PureComponent {
    state = {};

    copyUrl = () => {
        const { url, onCopy } = this.props;
        copyFn(url).catch(() => undefined);
        onCopy && onCopy(url);
    };

    render() {
        const { className, url } = this.props;

        let classNames = ['fm-copy-link'];
        if (className) classNames.push(className);

        return (
            <div className={classNames.join(' ')}>
                <a href={url} target="_blank" rel="noreferrer">
                    {url}
                </a>
                <span className="fm-copy-link__icon" onClick={this.copyUrl}>
                    <CopyIcon />
                </span>
            </div>
        );
    }
}

CopyLink.propTypes = {
    url: PropTypes.string,
    onCopy: PropTypes.func,
};

export default CopyLink;
